'use strict';

/** Import frontoffice_app */
import '../frontoffice_app';

/** Import FilterLinks */
import FilterLinks from '../../../shared/utility/filter_links/filter_links';

/** Import Pagination */
import Pagination from '../../../shared/pagination/pagination';

/** Import Cart class */
import Cart from '../../../shared/cart/cart';

/** @const TIRE_SEARCH */
const TIRE_SEARCH = 'tires/search';

/**
 * @class TiresSearchHandler
 */
class TiresSearchHandler
{
    /**
     * @constructor
     */
    constructor ()
    {
        this._setLinkActive();
        this._listenLinkByFilters();

        this.pagination = new Pagination({
            url: 'tire/pagination',
            activeStatistic: true,
            additionalFilters: [
                { selector: '#frontoffice-filter-tires-search', event: 'keyup', key: 'search', default: null },
                { selector: '#frontoffice-filter-tires-seasonId', event: 'change', key: 'seasonId', default: null },
                { selector: '#frontoffice-filter-tires-manufacturers', event: 'change', key: 'manufacturers', default: [] },
                { selector: '#frontoffice-filter-tires-widths', event: 'change', key: 'widths', default: [] },
                { selector: '#frontoffice-filter-tires-heights', event: 'change', key: 'heights', default: [] },
                { selector: '#frontoffice-filter-tires-diameters', event: 'change', key: 'diameters', default: [] },
                { selector: '.frontoffice-filter-tires-categoryId', event: 'click', key: 'categoryId', default: null, type: 'link' },
                { selector: '#price-range-input-button', event: 'click', key: { from: 'priceLower', to: 'priceUpper', range: '#price-range-input' }, default: null, type: 'range' }
            ],
            responseCallbacks: [ this._responseCallback ]
        });
    }

    /**
     * @private
     */
    _listenLinkByFilters ()
    {
        let that = this;

        $('.frontoffice-filter-tires-categoryId').on('click', (e) =>
        {
            let category = [],
                filters = FilterLinks.getFiltersCollectionFromLink(),
                catName = $(e.target)[0].innerText.split(' ')[0].replace('/', '$');

            if (catName !== 'Sve')
            {
                category = [catName];
            }
            filters['kategorija'] = category;
            that.constructor._generateLinkFromFilters(filters)
        });

        $('#frontoffice-filter-tires-heights').on('change', (e) =>
        {
            let filters = FilterLinks.getFiltersCollectionFromLink();
            filters['visina'] = $(e.target).val();
            that.constructor._generateLinkFromFilters(filters)
        });

        $('#frontoffice-filter-tires-widths').on('change', (e) =>
        {
            let filters = FilterLinks.getFiltersCollectionFromLink();
            filters['širina'] = $(e.target).val();
            that.constructor._generateLinkFromFilters(filters)
        });

        $('#frontoffice-filter-tires-diameters').on('change', (e) =>
        {
            let filters = FilterLinks.getFiltersCollectionFromLink();
            filters['prečnik'] = $(e.target).val();
            that.constructor._generateLinkFromFilters(filters)
        });

        $('#frontoffice-filter-tires-manufacturers').on('change', (e) =>
        {
            let manufacturers = [],
                filters = FilterLinks.getFiltersCollectionFromLink(),
                selected = $(e.target).val();

            $.each($('#frontoffice-filter-tires-manufacturers').find('option'), (k, v) =>
            {
                if (selected.indexOf($(v).val()) >= 0)
                {
                    manufacturers.push($(v)[0].innerText);
                }
            });
            filters['proizvođač'] = manufacturers;
            that.constructor._generateLinkFromFilters(filters)
        });

        $('#frontoffice-filter-tires-seasonId').on('change', (e) =>
        {
            let season = [],
                filters = FilterLinks.getFiltersCollectionFromLink(),
                selected = $(e.target).val();

            $.each($('#frontoffice-filter-tires-seasonId').find('option'), (k, v) =>
            {
                if ($(v).val() === selected && $(v)[0].innerText !== 'Izaberite opciju')
                {
                    season.push($(v)[0].innerText.split(' ')[0]);
                }
            });
            filters['sezona'] = season;
            that.constructor._generateLinkFromFilters(filters)
        });
    }

    /**
     * @private
     */
    _setLinkActive ()
    {
        let that = this;
        $('.frontoffice-filter-tires-categoryId').on('click', (e) =>
        {
            that._handleCategoryLinks($(e.target));
        })
    }

    /**
     * @param response
     * @private
     */
    _responseCallback (response)
    {
        let that = this, links = $('.frontoffice-filter-tires-categoryId'), setted = [];
        if (response.statistic && response.statistic.totalByCat)
        {
            $.each(response.statistic.totalByCat, (k, v) =>
            {
                $.each(links, (a, b) =>
                {
                    if ($(b).data('categoryid') && $(b).data('categoryid') === v.cat)
                    {
                        let text = $(b).text().split('(')[0];
                        $(b).text(text + ' (' + v.total + ')');
                        setted.push(v.cat);
                    }
                })
            });
            $.each(links, (c, d) =>
            {
                if ($(d).data('categoryid') && $(d).data('categoryid') > 0 && setted.indexOf($(d).data('categoryid')) < 0)
                {
                    let text = $(d).text().split('(')[0];
                    $(d).text(text + ' (0)');
                }
            })
        }

        if (response.statistic && response.statistic.manufacturer)
        {
            let manufacturersStr = '', manufacturerFilter = $('#frontoffice-filter-tires-manufacturers');
            $.each(response.statistic.manufacturer, (k, v) =>
            {
                manufacturersStr += '<option value="' + v.id + '">' + v.name + '</option>';
            });
            let manVal = manufacturerFilter.val();
            manufacturerFilter.empty();
            manufacturerFilter.html(manufacturersStr);
            manufacturerFilter.val(manVal);
            manufacturerFilter.trigger("chosen:updated");
        }

        if (response.statistic && response.statistic.width)
        {
            let widthStr = '', widthFilter = $('#frontoffice-filter-tires-widths');
            $.each(response.statistic.width, (k, v) =>
            {
                widthStr += '<option value="' + v.id + '">' + v.name + '</option>';
            });
            let widthVal = widthFilter.val();
            widthFilter.empty();
            widthFilter.html(widthStr);
            widthFilter.val(widthVal);
            widthFilter.trigger("chosen:updated");
        }

        if (response.statistic && response.statistic.height)
        {
            let heightStr = '', heightFilter = $('#frontoffice-filter-tires-heights');
            $.each(response.statistic.height, (k, v) =>
            {
                heightStr += '<option value="' + v.id + '">' + v.name + '</option>';
            });
            let heightVal = heightFilter.val();
            heightFilter.empty();
            heightFilter.html(heightStr);
            heightFilter.val(heightVal);
            heightFilter.trigger("chosen:updated");
        }

        if (response.statistic && response.statistic.diameter)
        {
            let diameterStr = '', diameterFilter = $('#frontoffice-filter-tires-diameters');
            $.each(response.statistic.diameter, (k, v) =>
            {
                diameterStr += '<option value="' + v.id + '">' + v.name + '</option>';
            });
            let diameterVal = diameterFilter.val();
            diameterFilter.empty();
            diameterFilter.html(diameterStr);
            diameterFilter.val(diameterVal);
            diameterFilter.trigger("chosen:updated");
        }

        $('.add_to_cart').on('click', (e) =>
        {
            e.preventDefault();
            Cart.addToCart($(e.target).data('cartitem'));
        })
    }

    /**
     * @param selected
     * @private
     */
    _handleCategoryLinks (selected)
    {
        let links = $('.frontoffice-filter-tires-categoryId');
        links.css({ 'color': '', 'font-weight': 'normal'});
        links.attr('data-selected', false);

        $.each(links, (k, v) =>
        {
            if ($(v).data('categoryid') === selected.data('categoryid'))
            {
                selected.css({ 'color': '#428BCA', 'font-weight': 'bold'});
                selected.attr('data-selected', true);
            }
        });
    }

    /**
     * @param filtersArray
     * @private
     */
    static _generateLinkFromFilters (filtersArray)
    {
        FilterLinks.generateLinkFromFilters(filtersArray, TIRE_SEARCH);
    }
}

/** Start TiresSearchHandler */
$(document).ready(() => { new TiresSearchHandler(); });


// WEBPACK FOOTER //
// ./assets/js/components/frontoffice/pages/tires.js